import { Form } from "antd/es";
import { FormInstance } from "antd/es/form";
import { PureComponent, ReactNode } from "react";
import KuikaInput from "../../../../ui-kit/kuika-input/kuika-input";
import KuikaSwitch from "../../../../ui-kit/kuika-switch/kuika-switch";
import { ConfigField } from "../config-pane-parts";

/** No props: both fields are real `Form.Item`s now, so the form is the only state they have. */
export class ConfigTwoFa extends PureComponent {
  integerValidator = async (_rule: unknown, value: string): Promise<void> => {
    if (!value) return;
    const val: number = Number(value);
    if (!Number.isInteger(val)) throw new Error("2F Auth Duration should be an integer");
    if (val < 0) throw new Error("2F Auth Duration should value be positive");
  };

  render(): ReactNode {
    return (
      <>
        <ConfigField label="2F Auth" tooltipContentKey="appsettings_2fauth_description">
          <Form.Item name={["apiConfig", "isTwoFactorAuthenticationEnabled"]} valuePropName="checked" noStyle>
            <KuikaSwitch dataTestId="appSettings2FAuthSwitch" />
          </Form.Item>
        </ConfigField>
        {/* The duration only means something while 2F Auth is on, and it must UNMOUNT rather
            than merely hide while it is off: that already matched today's behavior before
            this field had a real Form.Item, so submit semantics here do not change. */}
        <Form.Item
          shouldUpdate={(prev, current): boolean =>
            prev.apiConfig?.isTwoFactorAuthenticationEnabled !== current.apiConfig?.isTwoFactorAuthenticationEnabled
          }
          noStyle
        >
          {({ getFieldValue }: FormInstance): ReactNode => {
            const isEnabled: boolean = getFieldValue(["apiConfig", "isTwoFactorAuthenticationEnabled"]) ?? false;
            if (!isEnabled) return null;

            return (
              <ConfigField label="2 Auth Duration" tooltipContentKey="appsettings_2fauth_2fauthduration">
                <Form.Item
                  name={["apiConfig", "twoFactorAuthenticationDayLimit"]}
                  rules={[{ validator: this.integerValidator }]}
                >
                  <KuikaInput size="md" type="number" min={0} rightUnit="days" />
                </Form.Item>
              </ConfigField>
            );
          }}
        </Form.Item>
      </>
    );
  }
}
